import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";

export interface ILicenceVersion {
  licence_id: string;
  reg_no: string;
  licenceprofile_id: string;
  licence_type: string;
  licence_name: string;
  date_of_licence: string;
  ceased_date: string;
  licence_status: string;
  licence_substatus: string;
  licence_application_status: string;
  licenceprofile_number: string;
  urban_areape: string;
}

export interface ILicenceVersionsList {
  list: ILicenceVersion[];
  count: number;
  length: number;
  page: number;
}

export async function GetAllLicenceVersionsAsync(
  profileId: string
): Promise<ILicenceVersionsList> {
  var url = `${API_URL}/Licence/listbyprofileid?licence_profile_id=${profileId}&order_by=regno%5Bdesc%5D`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-versions`;
  }

  var response = await fetch(url);
  var body = <ILicenceVersionsList>await response.json();
  body.list = body.list.map((item) => {
    return <ILicenceVersion>{
      licence_id: item.licence_id,
      reg_no: item.reg_no,
      licenceprofile_id: item.licenceprofile_id,
      licence_type: item.licence_type,
      licence_name: item.licence_name,
      date_of_licence: formatDate(item.date_of_licence),
      ceased_date: formatDate(item.ceased_date),
      licence_status: item.licence_status,
      licence_substatus: item.licence_substatus,
      licence_application_status: item.licence_application_status,
      licenceprofile_number: item.licenceprofile_number,
      urban_areape: item.urban_areape,
    };
  });
  return body;
}

export async function GetLicenceVersionAsync(
  licenceId: string
): Promise<ILicenceVersion> {
  var url = `${API_URL}/Licence/byid?licence_id=${licenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-version-details`;
  }

  var response = await fetch(url);
  var body = <ILicenceVersion>await response.json();

  return {
    licence_id: licenceId,
    reg_no: body.reg_no,
    licenceprofile_id: body.licenceprofile_id,
    licence_type: body.licence_type,
    licence_name: body.licence_name,
    date_of_licence: formatDate(body.date_of_licence),
    ceased_date: formatDate(body.ceased_date),
    licence_status: body.licence_status,
    licence_substatus: body.licence_substatus,
    licence_application_status: body.licence_application_status,
    licenceprofile_number: body.licenceprofile_number,
    urban_areape: body.urban_areape,
  };
}

export const GetLicencesByMeetingFetchUrl = (
  meetingId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;
  let url = `${API_URL}/Licence/listbymeetingid?meeting_id=${meetingId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licences-by-meeting`;
  }

  return url;
};

export const GetLicenceVersionsDummy = (
  profileId: string
): ILicenceVersionsList => {
  return {
    count: 1,
    length: 50,
    page: 1,
    list: [
      {
        licence_id: "15019058-e564-e811-a2d5-0050568a66b2",
        reg_no: "W0297-01",
        licenceprofile_id: "e4915db9-de64-e811-a2d5-0050568a66b2",
        licence_type: "Waste",
        licence_name: "Harp Refrigerants Limited",
        date_of_licence: "2018-07-24T00:00:00",
        ceased_date: "2021-07-24T00:00:00",
        licence_status: "Ceased (Never Commenced)",
        licence_substatus: "",
        licence_application_status: "Licensed",
        licenceprofile_number: "W0297",
        urban_areape: "",
      },
      {
        licence_id: "15019058-e568-e811-a2d5-0050568a66b2",
        reg_no: "W0297-02",
        licenceprofile_id: "e4915db9-de64-e811-a2d5-0050568a66b2",
        licence_type: "Waste",
        licence_name: "Harp Refrigerants Limited",
        date_of_licence: "2018-07-24T00:00:00",
        ceased_date: "2021-07-24T00:00:00",
        licence_status: "Licensed",
        licence_substatus: "",
        licence_application_status: "Licensed",
        licenceprofile_number: "W0297",
        urban_areape: "",
      },
    ],
  };
};

export const GetActiveLicenceVersionDummy = (
  profileId: string
): ILicenceVersion => {
  return {
    licence_id: "15019058-e564-e811-a2d5-0050568a66b2",
    reg_no: "W0297-01",
    licenceprofile_id: "e4915db9-de64-e811-a2d5-0050568a66b2",
    licence_type: "Waste",
    licence_name: "Harp Refrigerants Limited",
    date_of_licence: "2018-07-24T00:00:00",
    ceased_date: "2021-07-24T00:00:00",
    licence_status: "Ceased (Never Commenced)",
    licence_substatus: "",
    licence_application_status: "Licensed",
    licenceprofile_number: "W0297",
    urban_areape: "Urban Area PE",
  };
};

export const IsIndustrialEmissionsLicense = (licence: ILicenceVersion) => {
  return licence.licence_type === "Industrial Emissions Licence";
};

export const IsWasteLicense = (licence: ILicenceVersion) => {
  return licence.licence_type === "Waste";
};

export const IsWasteWaterDischargeAuthorisation = (
  licence: ILicenceVersion
) => {
  return licence.licence_type === "Waste Water Discharge Authorisation";
};

export const IsCoALicense = (licence: ILicenceVersion) => {
  return licence.licence_type === "Certificate of Authorisation";
};

export const IsDumpingAtSeaLicense = (licence: ILicenceVersion) => {
  return licence.licence_type === "Dumping at Sea Permit";
};

export const IsORPLicense = (licence: ILicenceVersion) => {
  return licence.licence_type === "Radiological Protection Licence";
};
